import { Notification } from '@missionlabs/react'
import { UserActivity } from '@missionlabs/types'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { NotificationProps } from 'shared/components/Notifications/types'
import { useActivityInfo } from 'shared/hooks/useActivityInfo'

export const VoicemailNotification: FC<NotificationProps<UserActivity>> = ({
    item: activity,
    navigate,
    onClose
}) => {
    const { t } = useTranslation()
    const { name, company, team } = useActivityInfo(activity)

    const onDismiss = () => {
        if (!activity) return
        onClose(activity.ID)
    }

    const onVoicemail = () => {
        if (!activity) return
        navigate({ pathname: `/home/feed` }, { state: { activityID: activity.ID } })
    }

    if (!activity) return null

    return (
        <Notification
            variant="voicemail"
            header={t('notifications.voicemail')}
            name={name}
            role={company}
            via={team}
            onVoicemail={onVoicemail}
            onDismiss={onDismiss}
        />
    )
}
